module.exports = __webpack_public_path__ + "img/loseEfficacy.a71e72b6.png";